export enum ScreenDepth {
  /*keep the order*/
  MAIN_CONTAINER = 0,
  HIDDEN_INPUTS = -1,
  RICH_TEXT_EDITOR_LABEL = 1,
  HEADER_MULTISELECT_BLANKET = 4,
  HEADER_FORM_CONTROLS = 5,
  STICKY_LEFT_CELL = 8,
  LANG_SWITCH_PANEL = 10,
  MAP_CONTAINER = 14,
  LAYOUT_RIGHT_FOOTER = 15,
  GRID_SPLITTER = 17,
  HEADER = 19,
  HEADER_MOBILE = 20,
  MAP_CAR_MARKER = 21,
  /**
   * Live-map incident markers — above `.leaflet-marker-pane` (600) and `.leaflet-tooltip-pane` (650),
   * below `.leaflet-popup-pane` (700) so car/ride popups still cover the pin when open.
   */
  MAP_LIVE_INCIDENTS_LEAFLET_PANE = 680,
  /**
   * Live-map trail legend overlay — a direct child of `.leaflet-container` (via mapExtraLayers), so it
   * stacks above `.leaflet-map-pane` (the whole map) and stays visible in fullscreen. Kept below the
   * leaflet zoom / fullscreen controls (~1000).
   */
  MAP_TRACKING_TRAIL_LEGEND = 800,
  /** Live-map course-code vehicle marker icon (`.map-marker-icon--course-code`). */
  MAP_COURSE_CODE_MARKER = 890,
  /**
   * Local stacking layers *inside* a course-code marker (its own stacking context,
   * so only their order relative to each other matters, not the absolute values):
   * detour pulse ring sits behind the pin, the label sits above the pin.
   */
  MAP_COURSE_MARKER_DETOUR_PULSE = 11,
  MAP_COURSE_MARKER_PIN = 12,
  MAP_COURSE_MARKER_LABEL = 13,
  /**
   * Deep Ride Investigation — local stacking inside the panel/timeline (their own stacking contexts,
   * so only the order relative to each other matters, not the absolute values). Values are unique to
   * satisfy no-duplicate-enum-values, but each only competes within its own container.
   */
  INVESTIGATION_TIMELINE_TICK = 2,
  INVESTIGATION_TIMELINE_TICK_ACTIVE = 3,
  INVESTIGATION_TIMELINE_PLAYHEAD = 7,
  INVESTIGATION_PANEL_TABS = 9,
  /** Incident popups — above default popups so the card is never covered by map markers. */
  MAP_LIVE_INCIDENT_POPUP_LEAFLET_PANE = 900,
  /** Vehicle tracking popup on live map (above incident popup pane). */
  MAP_VEHICLE_TRACKING_POPUP = 1100,
  /** Place-info popup on any MapLibre map — above every marker (course-code vehicles are 890). */
  MAP_MAPLIBRE_PLACE_INFO_POPUP = 1050,
  /** MapLibre trail-point hover tooltip — below station/ride popups (Leaflet tooltipPane parity). */
  MAP_MAPLIBRE_TRAIL_TOOLTIP = 650,
  /** MapLibre station info popup — above the trail-point tooltip (Leaflet popupPane parity). */
  MAP_MAPLIBRE_STATION_POPUP = 700,
  LAYOUT_RIGHT_ROUTE_ANIMATION_CONTAINER = 23,
  LAYOUT_RIGHT_OVER_BACKDROP = 25,
  MENU_DRAWER_BACKDROP = 49,
  LEFT_BAR = 50,
  FLOATING_MENU = 22, // should be less then LAYOUT_RIGHT_ROUTE_ANIMATION_CONTAINER z-index to be behind drawers
  LAYOUT_RIGHT_BACKDROP = 101,
  RYDE_STATION_DRAG_CLONE = 102,
  TABLE_SETTING_COLUMN_DRAG_CLONE = 104,
  DRAG_OVERLAY = 200,
  /**
   * Deep Ride Investigation full-screen overlay — above the drawer backdrop (101) and drag clones (200), and
   * below DROPDOWN_MENU/MAP_ATTRIBUTIONS so popovers and confirm dialogs opened from inside it still paint on
   * top. The number to beat is 101: everything higher in this enum lives inside the drawer's own stacking
   * context, so those values say nothing about what sits above the drawer itself.
   */
  RIDE_INVESTIGATION_OVERLAY = 300,
  RIDE_START_END_DATE_EDITABLE = 199,
  /**
   * Base-tile selector on a MapLibre map. Map chrome, so it sits above everything drawn inside the map
   * (markers, popups, legends) but BELOW `MAP_ATTRIBUTIONS`, which a screen's own in-map controls and
   * panels use — those have to be able to cover it, as they did when this was a Leaflet control living
   * inside the map's own control pane.
   */
  MAP_MAPLIBRE_LAYER_CONTROL = 950,
  DROPDOWN_MENU = 1000,
  MAP_ATTRIBUTIONS = 1001,
  COLOR_PICKER_POPPER = 1500,
  CONTENT_BLUR_OVERLAY = 9999,
  INNER_ITEM_EDIT = 10000,
  INNER_ITEM_EDIT_PORTALS = 999999,
}
